import { Component } from 'react';
import { FaRedo } from 'react-icons/fa';
import './RouteErrorBoundary.css';

export default class RouteErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    const isArabic = document.documentElement.lang === 'ar';
    return (
      <section className="route-error" role="alert">
        <div>
          <span>Home Style</span>
          <h1 className="display-heading">{isArabic ? 'تعذّر عرض هذه الصفحة' : 'We could not display this page'}</h1>
          <p>{isArabic ? 'حدث خطأ غير متوقع. أعد تحميل الصفحة للمتابعة.' : 'Something unexpected happened. Reload the page to continue.'}</p>
          <button type="button" className="btn-brand" onClick={() => window.location.reload()}>
            <FaRedo aria-hidden="true" />{isArabic ? 'إعادة التحميل' : 'Reload page'}
          </button>
        </div>
      </section>
    );
  }
}
